import React, { useState, useEffect } from 'react';
import aerobicEfficiencyScreenshot from '../assets/aerobic_efficiency.png';
import weeklyAerobicEfficiency from '../assets/weekly_aerobic_efficiency.png';

const slides = [
  { src: aerobicEfficiencyScreenshot, caption: 'Your aerobic efficiency, visualised' },
  { src: weeklyAerobicEfficiency,     caption: 'Weekly aerobic efficiency trends' },
];

function ScreenshotCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setTimeout(() => {
      setCurrentIndex(i => (i + 1) % slides.length);
    }, 10000);
    return () => clearTimeout(timer);
  }, [currentIndex]);

  return (
    <>
      <div className="carousel">
        <button className="carousel-btn" onClick={() => setCurrentIndex(i => (i - 1 + slides.length) % slides.length)}>&#8249;</button>
        <img src={slides[currentIndex].src} alt={slides[currentIndex].caption} />
        <button className="carousel-btn" onClick={() => setCurrentIndex(i => (i + 1) % slides.length)}>&#8250;</button>
      </div>
      <p className="carousel-caption">{slides[currentIndex].caption}</p>
    </>
  );
}

export default ScreenshotCarousel;
